import { AddSubjectChangeApiInterface } from "@/ts/interfaces/Checkout/api/AddSubjectChangeApiInterface";
import { ProductFamilyApiInterface } from "@/ts/interfaces/Checkout/api/ProductFamilyApiInterface";
import { ValidateCouponResponseInterface } from "@/ts/interfaces/Checkout/api/ValidateCouponResponseInterface";
import { ApiResponseInterface } from "@/ts/interfaces/Misc/api/ApiResponseInterface";
import axios from "axios";

import { AddPremiumServiceApiInterface } from "@ts/interfaces/Checkout/api/AddPremiumServiceApiInterface";
import { ChargebeeSubscriptionApiInterface } from "@ts/interfaces/Checkout/api/ChargeApiInterface.ts";
import { UserCheckoutStateApiInterface } from "@ts/interfaces/Checkout/api/UserCheckoutStateApiInterface";
import { ValidateCouponApiInterface } from "@ts/interfaces/Checkout/api/ValidateCouponApiInterface";

export const fetchProductFamiliesApi = (productFamilyUrl: string) => {
    if (productFamilyUrl === "") {
        return null;
    }

    return axios.get<ProductFamilyApiInterface[]>(productFamilyUrl);
};

export const fetchExistingCardsApi = (chargebeeId: string) => {
    return axios.get(
        route("api.chargebee.getPaymentSources", { id: chargebeeId }) // nosonar
    );
};

export const postCheckoutStateApi = (
    data: UserCheckoutStateApiInterface,
    token: string | null
) => {
    return axios.post<ApiResponseInterface<{ token: string }>>(
        route("api.token.store", token ?? undefined),
        data
    ); // nosonar
};

export const fetchCheckoutStateApi = (token: string) => {
    return axios.get(route("api.token.retrieve", token)); // nosonar
};

export const postCreatePaymentIntentApi = (
    data: ChargebeeSubscriptionApiInterface
) => {
    return axios.post<
        ApiResponseInterface<{
            id: string;
            gateway_account_id: string;
            order_id: string;
        }>
    >(route("api.subscription.create-payment-intent"), data); // nosonar
};

export const postCreateCbSubscriptionApi = (
    data: ChargebeeSubscriptionApiInterface
) => {
    return axios.post<ApiResponseInterface<void>>(
        route("api.subscription.create-subscription"),
        data
    ); // nosonar
};

export const postAddPremiumServiceApi = <T>(
    data: AddPremiumServiceApiInterface
) => {
    return axios.post<ApiResponseInterface<T>>(
        route("api.premiumService.create"),
        data
    ); // nosonar
};

export const postAddSubjectChangesApi = <T>(
    data: AddSubjectChangeApiInterface
) => {
    return axios.post<ApiResponseInterface<T>>(
        route("api.chargebee.addSubjectChanges"),
        data
    ); // nosonar
};

export const postAddLicenseRenewPaymentApi = <T>(
    data: AddSubjectChangeApiInterface
) => {
    return axios.post<ApiResponseInterface<T>>(
        route("api.chargebee.addExtension"),
        data
    ); // nosonar
};

export const postValidateCouponApi = (data: ValidateCouponApiInterface) => {
    return axios.post<ApiResponseInterface<ValidateCouponResponseInterface>>(
        route("api.chargebee.applyCoupon"),
        data
    ); // nosonar
};

export const checkExistingUserApi = (data: { email: string }) => {
    return axios.get(route("auth.check-existing-user", data)); // nosonar
};

export const recaptchaVerifyApi = (data: { token: string }) => {
    return axios.post(route("api.recaptcha.verify"), data); // nosonar
};

export const validateEmailApi = (email: string, apiKey: string) => {
    return axios.get(
        `https://emailvalidation.abstractapi.com/v1/?api_key=${apiKey}&email=${email}`
    );
};

export const validatePhoneApi = (phone: string, apiKey: string) => {
    const response = axios.get(
        `https://phonevalidation.abstractapi.com/v1/?api_key=${apiKey}&phone=${phone.replace(
            /\+/g,
            ""
        )}`
    );

    return response;
};

export const licenseExtensionService = (id: string) => {
    return axios.get(
        route("api.students.manage.license-extension", { student: id })
    );
};